import { ApplicationRef, EnvironmentInjector, NgModule } from "@angular/core";
import { FloatuiDisplayComponent } from "./components/floatui-display.component";
import { CommonModule } from "@angular/common";
import { FloatUIHostDirective } from "./directives/floatui.directive";
import { FloatUIService } from "./services/floatui.service";

let SERVICE_INSTACE: FloatUIService |  undefined = undefined;

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        FloatuiDisplayComponent,
        FloatUIHostDirective,
    ],
    providers: [{
        provide: FloatUIService, 
        useFactory: (environmentInjector: EnvironmentInjector, appRef: ApplicationRef) => {
            if (!SERVICE_INSTACE) SERVICE_INSTACE = new FloatUIService(environmentInjector, appRef);
            return SERVICE_INSTACE
        },
        deps: [EnvironmentInjector, ApplicationRef]
    }],
    exports: [FloatuiDisplayComponent, FloatUIHostDirective]
})
export class FloatUIModule {}